export const skills_data = [
    {
        id: 1,
        name: "JavaScript",
        img: "javascript.svg"
    },
    {
        id: 2,
        name: "React",
        img: "react.svg"
    },
    {
        id: 3,
        name: "HTML5",
        img: "html5.svg"
    },
    {
        id: 4,
        name: "CSS3",
        img: "css3.svg"
    },
    {
        id: 5,
        name: "Tailwind CSS",
        img: "tailwindcss.svg"
    },
    {
        id: 6,
        name: "Git",
        img: "git.svg"
    },
    {
        id: 7,
        name: "Bootstrap",
        img: "bootstrap.svg"
    },
    {
        id: 8,
        name: "MongoDB",
        img: "mongodb.svg"
    },
    {
        id: 9,
        name: "Node.js",
        img: "nodejs.svg"
    },
    {
        id: 10,
        name: "Python",
        img: "python.svg"
    },
    {
        id: 12,
        name: "MySQL",
        img: "mysql.svg"
    },
    {
        id: 13,
        name: "Figma",
        img: "figma.svg"
    }
];